import { Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import BackgroundTheme from '../../../../Common/P2P/Header/BackgroundTheme';
import RoundButton from '../../../../Common/RoundButton';
import withdraw from '../../../../utils/assests/withdraw.svg';
import { logFirebaseEvent } from '../../firebase';
import { P2P_WITHDRAW_FUNDS_VIEW } from '../../firebase/constant';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import WithdrawalImg from '../../../../utils/assests/selected-icon.png';
const Withdrawal = () => {
  const history = useHistory();

  useEffect(() => {
    logFirebaseEvent(P2P_WITHDRAW_FUNDS_VIEW);
    document.title = 'stashearn - withdrawal';
  }, []);

  const handleSContinue = () => {
    history.push({ pathname: '/p2p/dashboard' });
  };

  return (
    <BackgroundTheme>
      <Card className='redBorder'>
        <CardContent>
          <Box className='circleImage'>
            <img src={WithdrawalImg} alt='' />
          </Box>

          <Box className='investSuccess'>
            <Typography variant='h1'>
              {/* You have selected <br /> a holding period of <br /> 12 months */}
              you will be able to withdraw your funds once the holding period ends
            </Typography>
            <Typography>
            {/* You will be able to withdraw<br />
            your investments after this ends */}
            </Typography>
          </Box>
          <Box className='tilThen'>
            <Typography variant='h1'>
              {/* Till then watch <br /> your investments grow */}
            </Typography>
          </Box>

          <RoundButton onClick={handleSContinue} title='Close' />
        </CardContent>
      </Card>
    </BackgroundTheme>
  );
};

export default Withdrawal;
